import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

const GenericError = ({ history, _, error, errorImg, errorFooterImg }) => {
  const handleBack = () => {
    history.push({
      pathname: "/",
      // state: { SignOutFromError: true },
    });
  };

  return (
    <div className="generic-error">
      <div className="generic-error-box">
        <div className="generic-error-mid">
          <img
            className="generic-error-mid-cubert"
            src={errorImg}
            alt="Error"
          />
          <h1>{error ? error : _.LooksLikeErrorOccurred}</h1>
          <p>
            {_.LetsTakeStep} <span onClick={handleBack}>{_.Back}</span>
            {" " + _.ToSafety}
          </p>
        </div>
        <div className="generic-error-foot">
          <img
            className="generic-error-foot-logo"
            src={errorFooterImg}
            alt="Logo"
          />
        </div>
      </div>
    </div>
  );
};

export default connect((state) => state)(withRouter(GenericError));
